/**
 * Access-control roles used by the internal Afriex admin dashboard for
 * back-office actions (compliance reviews, treasury operations, rate
 * uploads, etc.). String values persist to storage and cross the wire
 * unchanged, so members must keep their existing dotted-lowercase
 * representations.
 *
 * Historically declared in two places under different member-name
 * casings: admin used SCREAMING_SNAKE_CASE, server used snake_case.
 * Hoisted here with SCREAMING_SNAKE_CASE (TypeScript enum convention
 * for string-valued enums with symbolic names).
 */
export var AfriexRoles;
(function (AfriexRoles) {
    AfriexRoles["USER"] = "user";
    AfriexRoles["ENGINEERING_MANAGER"] = "engineering.manager";
    AfriexRoles["ENGINEERING_MEMBER"] = "engineering.member";
    AfriexRoles["CUSTOMER_SUPPORT_MANAGER"] = "customer.support.manager";
    AfriexRoles["CUSTOMER_SUPPORT_MEMBER"] = "customer.support.member";
    AfriexRoles["COMPLIANCE_MEMBER"] = "compliance.member";
    AfriexRoles["COMPLIANCE_MANAGER"] = "compliance.manager";
    AfriexRoles["FINANCE_MANAGER"] = "finance.manager";
    AfriexRoles["FINANCE_MEMBER"] = "finance.member";
    AfriexRoles["GROWTH_MANAGER"] = "growth.manager";
    AfriexRoles["GROWTH_MEMBER"] = "growth.member";
    AfriexRoles["OPERATIONS_MANAGER"] = "operations.manager";
    AfriexRoles["OPERATIONS_MEMBER"] = "operations.member";
    AfriexRoles["PEOPLES_OPERATIONS_MANAGER"] = "peoples.operations.manager";
    AfriexRoles["PEOPLES_OPERATIONS_MEMBER"] = "peoples.operations.member";
    AfriexRoles["PRODUCT_ENG_QA_DESIGN_MEMBER"] = "product.eng.qa.design.member";
    AfriexRoles["PRODUCT_ENG_QA_DESIGN_MANAGER"] = "product.eng.qa.design.manager";
})(AfriexRoles || (AfriexRoles = {}));
//# sourceMappingURL=AfriexRoles.js.map